import { call, put, takeLatest } from "redux-saga/effects";
import { 
  setCustomColumnViewSuccess, 
  setCustomColumnViewFailure,
  saveColumnBookmarkSuccess,
  saveColumnBookmarkFailure ,
  deleteCustomColumnSuccess,
  deleteCustomColumnFailure
} from "../reducers/drmCustomColumnSlice";
import { fetchCustomColumn } from "../../service/fetchCustomColumn";
import { drmCreateCustomColumn } from "../../service/drmCreateCustomColumn";
import { drmDeleteCustomColumn } from "../../service/drmDeleteCustomColumn";

export function* workerTableHeaderView({ payload }) {
  try {
    const response = yield call(fetchCustomColumn, [payload.body, payload.controller]);
    const fetchedColumn = response.details.data;
    yield put(setCustomColumnViewSuccess({
      views: fetchedColumn?.views || [],
      viewCategory: payload.body.viewCategory[0]
    }));

  } catch (error) {
    console.error("Error fetching custom table header:", error);
    yield put(setCustomColumnViewFailure("Failed to fetch custom table header"));
  }
}

export function* workerSaveBookmark({ payload }) {
  try {
    const { body ,applyOnly} = payload;
    if(!applyOnly){
      const response = yield call(drmCreateCustomColumn, [body]);
      yield put(saveColumnBookmarkSuccess());
    }
  } catch (error) {
    console.error("Error saving bookmark:", error);
    yield put(saveColumnBookmarkFailure("Failed to save bookmark"));
  }
}

export function* workerDeleteCustomColumn({ payload }) {
  try {
    const { body } = payload;
    const response =  yield call(drmDeleteCustomColumn, [body]);
    yield put(deleteCustomColumnSuccess());
  } catch (error) {
    console.error("Error deleting custom column:", error);
    yield put(deleteCustomColumnFailure("Failed to delete custom column"));
  }

}

function* drmCustomColumnSaga() {
  yield takeLatest("customColumn/getColumView", workerTableHeaderView);
  yield takeLatest("customColumn/saveColumnBook", workerSaveBookmark);
  yield takeLatest("customColumn/deleteCustomColumn", workerDeleteCustomColumn);
}

export default drmCustomColumnSaga;
